import { useRef, useEffect } from "react";
import Spline from "@splinetool/react-spline";
import PropTypes from "prop-types";

function SplineRandom({ isPlaying }) {
  const splineRef = useRef();

  useEffect(() => {
    if (splineRef.current) {
      splineRef.current.renderOnDemand = !isPlaying;
    }
  }, [isPlaying]);

  return (
    <Spline
      ref={splineRef}
      scene="https://prod.spline.design/Vih3zaDeRcKeEilT/scene.splinecode" // Replace with your actual Spline scene URL
    />
  );
}

SplineRandom.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
};

export default SplineRandom;
